import { Component } from '@angular/core';

@Component({
  selector: 'app-sso-frontpage',
  templateUrl: './sso-frontpage.component.html',
  styleUrls: ['./sso-frontpage.component.scss'],
})
export class SsoFrontpageComponent {}
